import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/no-visibility.svg
 */
const IconNoVisibility: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.212 12.439l.004-.004.02-.02.088-.086c.08-.077.2-.19.358-.33.316-.281.783-.674 1.38-1.111 1.196-.876 2.895-1.92 4.924-2.614 2.026-.693 4.366-1.031 6.865-.52 2.493.512 5.196 1.88 7.938 4.686a.706.706 0 101.01-.987c-2.914-2.982-5.862-4.507-8.665-5.081-2.798-.574-5.397-.189-7.604.566-2.204.753-4.03 1.88-5.303 2.811-.637.467-1.14.889-1.484 1.195a14.327 14.327 0 00-.502.469l-.029.029-.008.008-.002.002-.001.001.488.477-.488-.477a.707.707 0 001.01.986z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.789 11.656a.706.706 0 011.01.986l-.505-.492.506.492-.004.004-.008.008-.029.029-.105.103c-.092.088-.225.212-.397.366-.345.306-.847.727-1.484 1.195-1.272.932-3.099 2.058-5.303 2.811-2.207.755-4.806 1.14-7.604.566-2.803-.574-5.75-2.1-8.665-5.081a.706.706 0 111.01-.987c2.742 2.806 5.445 4.174 7.938 4.685 2.499.512 4.839.174 6.865-.519 2.029-.693 3.728-1.738 4.924-2.614.597-.437 1.064-.83 1.38-1.111a13.033 13.033 0 00.446-.415l.02-.02.005-.006z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.806 8.111a3.998 3.998 0 100 7.996 3.998 3.998 0 000-7.996zm-5.41 3.998a5.41 5.41 0 1110.82 0 5.41 5.41 0 01-10.82 0z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.609 8.817a1.462 1.462 0 100 2.923 1.462 1.462 0 000-2.923zm-2.874 1.462a2.874 2.874 0 115.747 0 2.874 2.874 0 01-5.747 0z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.746 5.593a.85.85 0 01-.339 1.153l-22 12a.85.85 0 01-.814-1.492l22-12a.85.85 0 011.153.339z"
      fill="currentColor"
    />
  </svg>
);

export default IconNoVisibility;
